import React from 'react'
import { ResponsiveBar } from '@nivo/bar'
import moment from 'moment';

const BarChart = ({data, keys, legend, format}) => {
	return (
		<ResponsiveBar
        data={data}
        keys={keys}
        indexBy={'day'}
        margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
        padding={0.3}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={{ scheme: 'nivo' }}
        defs={[
            {
                id: 'dots',
                type: 'patternDots',
                background: 'inherit',
                color: '#38bcb2',
                size: 4,
                padding: 1,
                stagger: true
            },
            {
                id: 'lines',
                type: 'patternLines',
                background: 'inherit',
                color: '#eed312',
                rotation: -45,
                lineWidth: 6,
                spacing: 10
            }
        ]}
        fill={[
            {
              match: {
                id: 'Mon'
              },
              id: 'dots'
            },
            {
              match: {
                id: 'Tues'
              },
              id: 'dots'
            },
            {
              match: {
                id: 'Wed'
              },
              id: 'lines'
            },
            {
              match: {
                id: 'Thurs'
              },
              id: 'dots'
            },
            {
              match: {
                id: 'Fri'
              },
              id: 'lines'
            },
            {
              match: {
                id: 'Sat'
              },
              id: 'lines'
            },
            {
              match: {
                id: 'Sun'
              },
              id: 'lines'
            },
          ]}
        borderColor={{
            from: 'color',
            modifiers: [
                [
                    'darker',
                    1.6
                ]
            ]
        }}
        axisTop={null}
        axisRight={null}
        valueFormat={value =>
            legend === 'income' ? `₵ ${Number(value).toLocaleString('en', {
                minimumFractionDigits: 2
            })}`: value
        }
        axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'days',
            legendPosition: 'middle',
            legendOffset: 32
        }}
        tooltip={(details) => {
          const { value, color, data } = details; 
          return (
            <div
              style={{
                  padding: 12,
                  color,
                  fontSize: '12px',
                  background: '#222222',
              }}
          >
              <span>{moment(data.tooltip).format('dddd ll')}</span>
              <br />
              <p>
                {legend === 'income' ? `Income: GH₵ ${value.toFixed(2)}`: `Total Trips: ${value}`} 
              </p>
          </div>
          )
        }}
        axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend,
            legendPosition: 'middle',
            legendOffset: -40
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{
            from: 'color',
            modifiers: [
                [
                    'darker',
                    1.6
                ]
            ]
        }}
        legends={[
            {
                dataFrom: 'keys',
                anchor: 'bottom-right',
                direction: 'column',
                justify: false,
                translateX: 120,
                translateY: 0,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: 'left-to-right',
                itemOpacity: 0.85,
                symbolSize: 20,
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ]}
        role="application"
        ariaLabel="Nivo bar chart demo"
        barAriaLabel={function(e){
          // console.log('ev', e);
          return e.id+": "+e.formattedValue+" in days: "+e.indexValue
        }}
    />
	)
}

export default BarChart
